import Link from 'next/link'

import { Box } from '@mui/material'
import Image from 'next/legacy/image'

import { resolveSanityImage } from '@/helpers/resolveSanityImage'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { Media as MediaProps } from '@/gen/sanity/schema'

export const Media: React.FC<MediaProps> = ({ media, externalName, link, width = 100, height = 100 }) => {
  const { language } = useTranslations()

  const url = resolveSanityImage(media)?.width(width).height(height).crop('entropy').fit('scale').auto('format').url()

  if (!url) {
    return null
  }

  const image = <Image src={url} width={width} height={height} alt={(!!externalName && externalName[language]) || ''} />

  if (link?.url && (link?.urlType === 'relativeUrl' || link?.urlType === 'absoluteUrl')) {
    return (
      <a href={link.url} target={link.openInNewTab ? '_blank' : undefined}>
        {image}
      </a>
    )
  }

  if (link?.urlType === 'differentProtocolUrl') {
    return <Link href={link.url ?? '#'}>{image}</Link>
  }

  if (link?.noUrl) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        {image}
      </Box>
    )
  }

  return null
}
